import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import {
  fetchAllBenefits,
  addBenefit,
  removeBenefit,
  updateBenefit,
} from '../actions/benefit.action'
import { Benefit, UpdateBenefitThunkParams } from '@dataTypes/index'

type BenefitState = {
  data: Benefit[] | null
  loading: boolean
  error: null
}

const initialState: BenefitState = {
  data: null,
  loading: false,
  error: null,
}

const benefitsSlice = createSlice({
  name: 'benefits',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      fetchAllBenefits.fulfilled,
      (state, action: PayloadAction<Benefit[]>) => {
        state.data = action.payload
        state.loading = false
      },
    )
    builder.addCase(fetchAllBenefits.pending, (state) => {
      state.loading = true
    })
    builder.addCase(fetchAllBenefits.rejected, (state) => {
      state.error = null
      state.loading = false
    })

    builder.addCase(
      addBenefit.fulfilled,
      (state, action: PayloadAction<Benefit>) => {
        state.data = state.data
          ? [...state.data, action.payload]
          : [action.payload]
        state.loading = false
      },
    )
    builder.addCase(addBenefit.pending, (state) => {
      state.loading = true
    })
    builder.addCase(addBenefit.rejected, (state) => {
      state.error = null
      state.loading = false
    })

    builder.addCase(
      updateBenefit.fulfilled,
      (state, action: PayloadAction<UpdateBenefitThunkParams>) => {
        const { id, body: updatedBenefit } = action.payload
        if (!state.data) return
        const index = state.data.findIndex((item) => item.id === id)
        if (index !== -1) {
          state.data[index] = { ...state.data[index], ...updatedBenefit }
        }
        state.loading = false
      },
    )
    builder.addCase(updateBenefit.pending, (state) => {
      state.loading = true
    })
    builder.addCase(updateBenefit.rejected, (state) => {
      state.error = null
      state.loading = false
    })

    builder.addCase(removeBenefit.fulfilled, (state, action) => {
      const id = action.payload
      if (!state.data) return
      const index = state.data.findIndex((item) => item.id === id)
      if (index !== -1) {
        state.data && state.data.splice(index, 1)
      }
      state.loading = false
    })
    builder.addCase(removeBenefit.pending, (state) => {
      state.loading = true
    })
    builder.addCase(removeBenefit.rejected, (state) => {
      state.error = null
      state.loading = false
    })
  },
})

export default benefitsSlice.reducer
